import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const ManageAppsDetailsPage = React.lazy(() => import(/* webpackChunkName: "ManageAppsDetails" */ './ManageAppsDetails'));
export const ManageAppsDetails = () => (React.createElement(Page, { title: "View available case details", description: "View available details of appearance according to area" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(ManageAppsDetailsPage, null)))));
